import React from 'react';
import { logSafelyToConsole } from 'utils';
import { GET } from 'utils/useApi';
import { ITutorProfileListItem } from 'types';
import { TutorSearchParams, TutorSearchResponse } from 'types/Api';
import { isUAE } from 'utils/env';
import { getSavedLevel, getSavedSubject } from 'utils/useSessionStorage';

export enum TutorCardsActionType {
  SEARCH_TUTORS_REQUEST = 'SEARCH_TUTORS_REQUEST',
  SEARCH_TUTORS_SUCCESS = 'SEARCH_TUTORS_SUCCESS',
  SEARCH_TUTORS_ERROR = 'SEARCH_TUTORS_ERROR'
}

export interface TutorsPayload {
  tutors: ITutorProfileListItem[];
  totalCount: number;
  nextPage: string | null;
}

export const requestSearchTutors = async (
  dispatch: React.Dispatch<{
    type: TutorCardsActionType;
    payload: TutorsPayload | null;
  }>,
  subject: string,
  level: string,
  limit: number
): Promise<void> => {
  const {
    SEARCH_TUTORS_REQUEST,
    SEARCH_TUTORS_SUCCESS,
    SEARCH_TUTORS_ERROR
  } = TutorCardsActionType;

  dispatch({
    type: SEARCH_TUTORS_REQUEST,
    payload: null
  });

  try {
    const useToken = true;

    const params: TutorSearchParams = {
      max_experience: 60,
      max_price: isUAE ? 400 : 90,
      min_experience: 0,
      min_price: isUAE ? 50 : 20,
      online: true,
      subject_id: `${getSavedSubject}`,
      level_id: `${getSavedLevel}`,
      limit
    };

    const query = new URLSearchParams(params as any);
    const searchResult = (await GET(
      `v2/tutor/?${query}`,
      useToken
    )) as TutorSearchResponse;
    const { data } = searchResult;
    logSafelyToConsole(JSON.stringify(data));
    const { results, count, next } = data;

    let nextPage = null;
    if (next) {
      nextPage = next.split('?page=')[1];
    }

    dispatch({
      type: SEARCH_TUTORS_SUCCESS,
      payload: {
        tutors: results,
        totalCount: count,
        nextPage
      }
    });
  } catch (err) {
    dispatch({
      type: SEARCH_TUTORS_ERROR,
      payload: null
    });
  }
};
